/**
 * Design tokens Alterrego.
 * Palette strictement bleue/froide — jamais d'or, brun, beige, ocre.
 */

export const tokens = {
  color: {
    // Palette canonique Alterrego
    primary: '#1464B4',
    primaryDark: '#2864A0',
    ink: '#3C3C50',
    // Neutres froids uniquement
    white: '#FFFFFF',
    grey50: '#F7F8FA',
    grey100: '#EEF1F5',
    grey200: '#D8DEE6',
    grey400: '#8A93A3',
    grey600: '#4A5161',
    // Sémantique (variantes de bleu pour feedback, pas de rouge/vert/orange chauds)
    info: '#1464B4',
    success: '#2864A0',
    danger: '#0F3A6B',
  },
  radius: {
    sm: '6px',
    md: '12px',
    lg: '20px',
    full: '9999px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  font: {
    family: '"DM Sans", -apple-system, system-ui, sans-serif',
    size: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '20px',
      xl: '28px',
      xxl: '40px',
    },
    weight: {
      regular: 400,
      medium: 500,
      bold: 700,
    },
  },
  shadow: {
    sm: '0 1px 2px rgba(60, 60, 80, 0.06)',
    md: '0 4px 12px rgba(60, 60, 80, 0.10)',
    lg: '0 12px 32px rgba(60, 60, 80, 0.14)',
  },
} as const;

export type Tokens = typeof tokens;
